import moment from 'moment';

export const AUDIT_ACTION_LABELS = {
    CREATED: 'Created',
    EDITED: 'Edited',
    DELETED: 'Deleted',
};

const FIELD_LABELS = {
    jobNo: 'Job No',
    masterJobNo: 'Master Job No',
    machineNo: 'Machine',
    lineNo: 'Line',
    masterID: 'Part ID',
    toolingID: 'Tooling ID',
    jsQuantity: 'Quantity',
    po: 'PO',
    manpower: 'Manpower',
    operationHours: 'Operation Hours',
    ot: 'OT',
    otSaturday: 'Saturday OT',
    materialBatchNo: 'Material Batch No',
    remark: 'Remark',
    start: 'Start',
    end: 'End',
};

export const formatAuditField = field => FIELD_LABELS[field] || field;

export function formatAuditValue(value) {
    if (value === null || value === undefined || value === '') return '—';
    if (value === true) return 'Yes';
    if (value === false) return 'No';
    return String(value);
}

export const formatAuditTime = value => (value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '—');

export function formatAuditUser(row) {
    const name = row && (row.displayName || row.username);
    return name || 'Unknown';
}

// One readable line per change; CREATED shows only the new value and
// DELETED only the old one.
export function formatAuditChange(action, change) {
    const label = formatAuditField(change.field);
    if (action === 'CREATED') return `${label}: ${formatAuditValue(change.to)}`;
    if (action === 'DELETED') return `${label}: ${formatAuditValue(change.from)}`;
    return `${label}: ${formatAuditValue(change.from)} → ${formatAuditValue(change.to)}`;
}

export const getAuditPageCount = (total, limit) => Math.max(1, Math.ceil((Number(total) || 0) / limit));

export const EMPTY_AUDIT_FILTERS = { from: '', to: '', action: '', jobNo: '' };

export const hasAuditFilters = filters => Boolean(filters.from || filters.to || filters.action || filters.jobNo.trim());

export const getAuditDateRangeError = (from, to) =>
    (from && to && from > to ? 'From date must be on or before To date.' : '');

// Picked dates are whole local days, sent as the exact start and end instants
// so the server does not need to know the user's time zone.
export function buildAuditQuery(filters, page, limit) {
    return {
        page,
        limit,
        from: filters.from ? moment(filters.from, 'YYYY-MM-DD').startOf('day').toISOString() : '',
        to: filters.to ? moment(filters.to, 'YYYY-MM-DD').endOf('day').toISOString() : '',
        action: filters.action,
        jobNo: filters.jobNo.trim(),
    };
}
